<template>
  <v-card-text style="color: #4F4F4F">
    <v-row class="pa-3">
      Sorry, that link has expired. Please ask your agency owner to go to License Management and click "resend link".
    </v-row>
  </v-card-text>
</template>

<script>

export default {
  name: 'Expired'
};

</script>
